import React, { useState } from "react";
import { LANGUAGES } from "./languages";

// ─── Language Selector Modal ──────────────────────────────────────────────────
export function LanguageSelector({ currentLang, onSelect, onClose }) {
  const [search, setSearch] = useState("");
  const filtered = LANGUAGES.filter(l =>
    l.name.toLowerCase().includes(search.toLowerCase()) ||
    l.nativeName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,0.5)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#FDF8F3",borderRadius:"22px 22px 0 0",width:"100%",maxWidth:560,maxHeight:"75vh",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"20px 20px 12px",borderBottom:"1px solid #F0E0D0",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <h2 style={{fontSize:18,fontWeight:800,color:"#5C3D2E",margin:0}}>Choose language</h2>
            <button onClick={onClose} style={{background:"#F0E0D0",border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:16,color:"#A08070",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>
          <input
            type="text"
            placeholder="Search languages…"
            value={search}
            onChange={e=>setSearch(e.target.value)}
            style={{width:"100%",border:"1.5px solid #E8D5C4",borderRadius:10,padding:"10px 14px",fontSize:14,color:"#5C3D2E",outline:"none",fontFamily:"inherit",boxSizing:"border-box",background:"#fff"}}
            onFocus={e=>e.target.style.borderColor="#A0673A"}
            onBlur={e=>e.target.style.borderColor="#E8D5C4"}
          />
        </div>
        <div style={{overflowY:"auto",padding:"12px 16px 24px",flex:1}}>
          {filtered.map(lang => (
            <button
              key={lang.code}
              onClick={()=>{onSelect(lang.code);onClose();}}
              style={{
                width:"100%",background:currentLang===lang.code?"#F5EDE4":"#fff",
                border:`1.5px solid ${currentLang===lang.code?"#A0673A":"#F0E0D0"}`,
                borderRadius:12,padding:"12px 16px",cursor:"pointer",
                display:"flex",alignItems:"center",gap:12,marginBottom:8,
                fontFamily:"inherit",transition:"all 0.15s",
              }}
            >
              <span style={{fontSize:22}}>{lang.flag}</span>
              <div style={{textAlign:"left"}}>
                <p style={{margin:0,fontSize:14,fontWeight:700,color:"#5C3D2E"}}>{lang.nativeName}</p>
                <p style={{margin:0,fontSize:12,color:"#A08070"}}>{lang.name}</p>
              </div>
              {currentLang===lang.code && <span style={{marginLeft:"auto",color:"#A0673A",fontSize:16}}>✓</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Crisis Resources Panel ───────────────────────────────────────────────────
export function CrisisPanel({ resources, onClose }) {
  const typeIcon = { call:"📞", sms:"💬", chat:"💻", whatsapp:"📱" };
  const typeLabel = { call:"Call", sms:"SMS", chat:"Online", whatsapp:"WhatsApp" };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,0.5)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#FDF8F3",borderRadius:"22px 22px 0 0",width:"100%",maxWidth:560,maxHeight:"80vh",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"20px 20px 14px",borderBottom:"1px solid #FECACA",flexShrink:0,background:"#FEF2F2",borderRadius:"22px 22px 0 0"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <h2 style={{fontSize:18,fontWeight:800,color:"#DC2626",margin:"0 0 2px"}}>
                {resources.flag} Crisis Support — {resources.country}
              </h2>
              <p style={{fontSize:12,color:"#EF4444",margin:0}}>You are not alone. Trained people are ready to help right now.</p>
            </div>
            <button onClick={onClose} style={{background:"#FECACA",border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:16,color:"#DC2626",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>✕</button>
          </div>
        </div>

        <div style={{overflowY:"auto",padding:"16px 20px 32px",flex:1}}>
          {resources.resources.map((r, i) => (
            <div key={i} style={{background:"#fff",borderRadius:14,padding:"16px",marginBottom:10,border:"1px solid #F0E0D0"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <p style={{fontSize:14,fontWeight:700,color:"#5C3D2E",margin:0,flex:1}}>{r.name}</p>
                <div style={{display:"flex",gap:6,flexShrink:0,marginLeft:8}}>
                  {r.free && <span style={{background:"#F0FDF4",color:"#16A34A",borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:600}}>Free</span>}
                  <span style={{background:"#FEF9F3",color:"#A0673A",borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:600}}>{r.available}</span>
                </div>
              </div>
              <a
                href={r.type==="call"?`tel:${r.number.replace(/\s/g,"")}`:r.type==="sms"?`sms:${r.number.replace(/\s/g,"")}`:r.number.startsWith("http")?r.number:`https://${r.number}`}
                style={{display:"flex",alignItems:"center",gap:10,background:r.type==="call"?"#DC2626":r.type==="sms"?"#7C3AED":"#1D4ED8",color:"#fff",textDecoration:"none",borderRadius:10,padding:"10px 16px",fontSize:14,fontWeight:700}}
              >
                <span style={{fontSize:18}}>{typeIcon[r.type]||"📞"}</span>
                <span>{typeLabel[r.type]||"Contact"}: {r.number}</span>
              </a>
            </div>
          ))}

          <div style={{background:"#FFF7ED",borderRadius:12,padding:"12px 16px",border:"1px solid #FED7AA",marginTop:8}}>
            <p style={{fontSize:12,color:"#92400E",margin:0,lineHeight:1.6}}>
              <strong>If you are in immediate danger</strong>, please call your local emergency services (911, 999, 112, or 10111 in South Africa) immediately.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Inline crisis banner (shown in responses) ────────────────────────────────
export function CrisisBanner({ resources, onViewAll }) {
  const primary = resources.resources[0];
  return (
    <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:12,padding:"12px 16px",marginBottom:18}}>
      <p style={{color:"#DC2626",fontSize:13,fontWeight:700,margin:"0 0 6px"}}>
        🆘 If you are in crisis — {resources.flag} {resources.country}
      </p>
      {primary && (
        <a href={`tel:${primary.number.replace(/\s/g,"")}`}
          style={{display:"inline-flex",alignItems:"center",gap:8,background:"#DC2626",color:"#fff",textDecoration:"none",borderRadius:8,padding:"8px 14px",fontSize:13,fontWeight:700,marginBottom:8}}>
          📞 Call {primary.name}: {primary.number}
        </a>
      )}
      <br/>
      <button onClick={onViewAll} style={{background:"none",border:"none",color:"#EF4444",fontSize:12,cursor:"pointer",fontFamily:"inherit",padding:0,textDecoration:"underline"}}>
        See all crisis resources for {resources.country}
      </button>
    </div>
  );
}
